

import Vue from 'vue'
import VueRouter from 'vue-router'
import location00 from '../views/location00.vue'
import location01 from '../views/location01.vue'
import location02 from '../views/location02.vue'
import location03 from '../views/location03.vue'
import location04 from '../views/location04.vue'
import location05 from '../views/location05.vue'


import location0111 from '../views/location0111.vue'
import location0112 from '../views/location0112.vue'
import location0121 from '../views/location0121.vue'

import location0211 from '../views/location0211.vue'
import location0212 from '../views/location0212.vue'
import location0221 from '../views/location0221.vue'


import location0311 from '../views/location0311.vue'
import location0312 from '../views/location0312.vue'
import location0313 from '../views/location0313.vue'
import location0314 from '../views/location0314.vue'

import location0411 from '../views/location0411.vue'
import location0421 from '../views/location0421.vue'
import location0422 from '../views/location0422.vue'

import location0511 from '../views/location0511.vue'
import location0512 from '../views/location0512.vue'

import location0521 from '../views/location0521.vue'
import location0522 from '../views/location0522.vue'
import location0531 from '../views/location0531.vue'
import location0541 from '../views/location0541.vue'
import location0542 from '../views/location0542.vue'

import location0551 from '../views/location0551.vue'
import location0561 from '../views/location0561.vue'

Vue.use(VueRouter)

const routes = [

  { 
    path: '/', 
    component:location00,
  },
  { 
    path: '/location00', 
    component:location00,
  },
  { 
    path: '/location01', 
    component:location01,
  },
  { 
    path: '/location02',
    component:location02,
  },
  { 
    path: '/location03',
    component:location03,
  },
  { 
    path: '/location04',
    component:location04,
  },
  { 
    path: '/location05',
    component:location05,
  },
  { 
    path: '/location0111',
    component:location0111,
  },
  { 
    path: '/location0112',
    component:location0112,
  },
  { 
    path: '/location0121',
    component:location0121,
  },
  { 
    path: '/location0211',
    component:location0211,
  },
  { 
    path: '/location0212',
    component:location0212,
  },
  { 
    path: '/location0221',
    component:location0221,
  },

  { 
    path: '/location0311',
    component:location0311,
  },
  { 
    path: '/location0312',
    component:location0312,
  },
  { 
    path: '/location0313',
    component:location0313,
  },
  { 
    path: '/location0314',
    component:location0314,
  },
  
  { 
    path: '/location0411',
    component:location0411,
  },

  { 
    path: '/location0421',
    component:location0421,
  },
  { 
    path: '/location0422',
    component:location0422,
  },
  { 
    path: '/location0511',
    component:location0511,
  },
  { 
    path: '/location0512',
    component:location0512,
  },

  { 
    path: '/location0521',
    component:location0521,
  },
  { 
    path: '/location0522',
    component:location0522,
  },
  { 
    path: '/location0531',
    component:location0531,
  },

  { 
    path: '/location0541',
    component:location0541,
  },

  { 
    path: '/location0542',
    component:location0542,
  },
  
  { 
    path: '/location0551',
    component:location0551,
  },
  { 
    path: '/location0561',
    component:location0561,
  },

  /*錯誤跳轉回家*/
  {
    path: '*',
    redirect: '/',
  }

]


const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

/*
router.beforeEach((to, from, next)=>{
  const isLogin = localStorage.getItem('token') == 'ImLogin' ;
  if( isLogin ){
    next();
  } else {
    if( to.path !== '/login')
      next('/login');
    else
      next();
  }
});
*/

export default router
